import React, { useState, useEffect } from 'react';
import moment from 'moment/moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons';
import { Row, Col, Button } from 'reactstrap';
//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from 'components/TabelaListagem/TabelaListagem';
import Loading from '../../components/Loading/Loading';
import ModalCustomized from '../../components/Modal/Modal';
//Api
import correioInterno_api from '../../api/correioInterno_api';

//Helpers
import { showMessage } from '../../helpers/message';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

export default function MensagemInterna() {

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos dados da mensagem selecionada para visualizar
    const [mensagem, setMensagem] = useState({});

    //Estado de controle da lista de mensagens
    const [mensagens, setMensagens] = useState([]);

    //Estado de controle de exibição do modal
    const [openModal, setOpenModal] = useState(false);

    //Função que troca o estado de exibição do modal
    const toggleModal = () => {
        if (openModal && mensagem.id) {
            correioInterno_api.AtualizaLeitura(mensagem.id).then(response => {
                loadCorreiosInternos();
                setMensagem({});
            }).catch(e => showMessage("Aviso", e.message, "error", null));
        }
        setOpenModal(!openModal);
    };

    //Carrega a lista de mensagens internas
    const loadCorreiosInternos = () => {
        setLoading(true);
        correioInterno_api.GetList().then(response => {
            response.data = response.data.map(value => {
                value.dataEnvio = moment(value.dataEnvio).format("DD/MM/YYYY HH:mm:ss");
                value.dataEnvioEmail = value.dataEnvioEmail ? moment(value.dataEnvioEmail).format("DD/MM/YYYY HH:mm:ss") : "";

                return value;
            });
            setMensagens(response.data);
        }).catch(e => { showMessage("Aviso", e.message, "error", null) })
            .finally(f => setLoading(false));
    }

    //Função de visualizar os dados da mensagem no modal
    const visualizarMensagem = (rowData) => {
        setLoading(true);
        correioInterno_api.GetItem(rowData.id).then(response => {
            setMensagem(response.data);
            toggleModal();
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Cabeçalhos da tabela
    const headers = [
        { value: "Título", objectValue: "titulo" },
        { value: "Data da mensagem", objectValue: "dataEnvio" },
        { value: "Data Envio", objectValue: "dataEnvioEmail" },
        { value: "Status", objectValue: "status" },
        { value: "Status Email", objectValue: "statusEmail" },
    ];

    //Ações da tabela
    const actions = [actionsTable.visualizar(visualizarMensagem)];

    //Carrega todas as mensagens assim que a tela é inicializada
    useEffect(() => {
        loadCorreiosInternos();
    }, []);

    return (
        <MainCard noCard>
            {loading && <Loading />}
            <ModalCustomized isOpen={openModal} toggle={toggleModal} title={mensagem?.titulo} btnClose>
                <div dangerouslySetInnerHTML={{ __html: mensagem?.mensagem }}></div>
                {!!mensagem?.anexos?.length > 0 && <>
                    <h5 className='bg-primary p-2 bg-gradient rounded-3 text-light'><FontAwesomeIcon icon={faFileAlt} /> Anexos</h5>
                    <Row>
                        {
                            mensagem?.anexos?.map((value, index) => {
                                return (
                                    <Col md="6" lg="2">
                                        <div className=' text-secondary mt-2 shadow d-flex flex-column align-items-center justify-content-center p-3 rounded-3'>
                                            <FontAwesomeIcon icon={faFileAlt} size={'4x'} />
                                            <p className='mt-2'>
                                                <a className='text-decoration-none text-light bg-primary p-1 rounded-3' href={value.caminho}>Baixar</a>
                                            </p>
                                        </div>
                                    </Col>
                                )
                            })
                        }
                    </Row>
                </>}
            </ModalCustomized>
            <TabelaListagem actions={actions} headers={headers} items={mensagens} options={{ print: false, search: true, pagination: true }} />
        </MainCard>
    );
}